"use strict";

const ModalMap = function () {
  var modalMap;
  var mapLayers;

  var blueDot;
  var currentBasemap;

  var modalMapHandlerConfiguration = {
    modalMapClickHandler: null,
    newExistingMarkerHandler: null,
    dragEndHandler: null,
  };

  var init = function () {
    LeafletExtensions.loadLeafletExtensions();
    $(window).on("resize", invalidateModalMapSize);
    mapLayers = LayerFunctions.getDefaultMapLayers();
    loadTreeListeners();
  };

  var resetModalMapHandlers = function () {
    Object.keys(modalMapHandlerConfiguration).forEach(function (key) {
      modalMapHandlerConfiguration[key] = null;
    });
  };

  var configureModalMapHandlers = function (newConfiguration) {
    Object.keys(modalMapHandlerConfiguration).forEach(function (key) {
      if (newConfiguration && newConfiguration[key] !== undefined) {
        modalMapHandlerConfiguration[key] = newConfiguration[key];
      }
    });
  };

  var initializeModalMap = function () {
    if (!modalMap) {
      loadModalMap();
      resetModalDisplayOptions();
      loadModalMapLayerListeners();
      setModalMapView();
    }
    afterOpenInventory();
    initModalMapLayers();
  };

  var afterOpenInventory = function () {
    DataViewFunctions.getCurrentDataViewProperty("afterOpenInventory")?.();
    MainMapController.loadLegend("modal");
  };

  var showModalMap = function () {
    initializeModalMap();
    setModalMapView();
    updateModalMapDisplay();
  };

  var updateModalMapDisplay = function () {
    $("#modalMap").show();
    setModalMapBasemap();
    invalidateModalMapSize();
    showBlueDot();
  };

  var invalidateModalMapSize = function () {
    if (modalMap) {
      modalMap.invalidateSize();
      BulkSelectTable.setBulkSelectTableHeight();
    }
  };

  var loadModalMap = function () {
    if (mapLayers === undefined) mapLayers = LayerFunctions.getDefaultMapLayers();

    modalMap = L.map("modalMap", {
      editable: true,
      zoomControl: false,
      tileLayer: {
        maxNativeZoom: 21,
      },
      minZoom: 3,
      maxZoom: 21,
    });

    MapPaneFunctions.createCustomMapPanes(modalMap);
    loadModalMapLegend();
    loadModalMapListeners();
    handleModalMapLayers();
    initCustomLayers();
    loadBoundary(modalMap);

    //when location is updated, move blueDot marker
    Tree.select("blueDotLatLng").on("update", function (e) {
      showBlueDot();
    });

    DisplayOptions.resetDisplayOptions();
    MapFunctions.addMapZoomControl(modalMap);
  };

  var loadModalMapLegend = function () {
    const legend = new L.Control.ModalMapLegend();
    modalMap.addControl(legend);
    MainMapController.loadLegend("modal");

    $("#modal-legend-group").off("wheel");
    $("#modal-legend-group").on("wheel", function (e) {
      e.stopPropagation();
    });
  };

  var setModalMapView = function () {
    if (modalMap) {
      const zoomLevel = Tree.get("zoomLevel");
      const mapCenter = Tree.get("mapCenter");
      modalMap.setView(mapCenter, zoomLevel);
    }
  };

  var setModalMapBasemap = function (mapStyle) {
    if (!mapStyle) {
      mapStyle = BasemapFunctions.getBasemap("modal", true);
    }
    if (modalMap) {
      currentBasemap = MapFunctions.addVectorBasemap(modalMap, currentBasemap, mapStyle);
    }
  };

  var handleModalMapLayers = function () {
    const catchments = Tree.get(["catchments", "items"]);
    mapLayers.catchmentsLayer = MapFunctions.addModalCatchLayer(
      modalMap,
      mapLayers.catchmentsLayer,
      catchments,
    );

    mapLayers.boundsLayer = createBoundaryLayer(modalMap);
    mapLayers.boundsLayer.addTo(modalMap);
  };

  var initModalMapLayers = function () {
    const defaultEnabledLayers = DataViewFunctions.getCurrentDataViewProperty("defaultModalLayers");

    if (defaultEnabledLayers) {
      MainMapController.enableLayers(defaultEnabledLayers, "modal");
    }
  };

  var initCustomLayers = function () {
    ToolSettings.getSetting("customEsriLayerSettings")?.layers.forEach(function (layer) {
      const layerName = CustomLayer.getCustomLayerKey(layer);
      mapLayers[layerName] = null;
      CustomLayer.init("modal", modalMap, mapLayers, layer);
    });
  };

  var loadModalMapListeners = function () {
    if (modalMap) {
      modalMap.off();
      modalMap.on("moveend zoomend", modalMapMoveZoomEnd);
      loadModalMapClickListeners();
    }
  };

  var resetModalMapClickListeners = function () {
    modalMap.off("click");
  };

  var loadModalMapClickListeners = function () {
    resetModalMapClickListeners();
    if (modalMapHandlerConfiguration.modalMapClickHandler !== null) {
      modalMap.on("click", modalMapHandlerConfiguration.modalMapClickHandler);
    }
  };

  var loadTreeListeners = function () {
    BasemapFunctions.addBasemapChangeListener(function (newBasemap) {
      setModalMapBasemap(newBasemap);
    }, "modal");
  };

  var loadModalMapLayerListeners = function () {
    LayerFunctions.loadAllLayerMapListeners(modalMap, mapLayers, "modal");

    MapFunctions.whenLayerToggled("fullDrainageBmp", "modal", function (fullDrainageBmpIsEnabled) {
      if (fullDrainageBmpIsEnabled) {
        if (mapLayers.fullDrainageBmpLayer) {
          MapFunctions.displayFullDrainageLayer(modalMap, mapLayers, "bmp");
        } else {
          Actions.loadFullDrainageBmp("modal");
        }
      } else {
        MapFunctions.removeFullDrainageBmp(modalMap, mapLayers);
      }
    });

    MapFunctions.whenLayerToggled("fullDrainageFcs", "modal", function (fullDrainageFcsIsEnabled) {
      if (fullDrainageFcsIsEnabled) {
        if (mapLayers.fullDrainageFcsLayer) {
          MapFunctions.displayFullDrainageLayer(modalMap, mapLayers, "fcs");
        } else {
          Actions.loadFullDrainageFcs("modal");
        }
      } else {
        MapFunctions.removeFullDrainageFcs(modalMap, mapLayers);
      }
    });

    MapFunctions.whenLayerToggled("stormdrains", "modal", function (stormdrainsIsEnabled) {
      if (stormdrainsIsEnabled) {
        if (mapLayers.stormdrainLayer) {
          StormdrainLayer.handleStormdrainDisplay(modalMap, mapLayers, "modal");
        } else {
          StormdrainLayer.loadStormdrains("modal");
        }
      } else {
        MapFunctions.hideStormdrains(modalMap, mapLayers);
      }
    });

    MapFunctions.whenLayerToggled("streams", "modal", function (isEnabled) {
      if (isEnabled) {
        if (mapLayers.rwLayer) {
          modalMap.addLayer(mapLayers.rwLayer);
        } else {
          Actions.loadWatersheds("modal");
        }
      } else {
        if (mapLayers.rwLayer) {
          modalMap.removeLayer(mapLayers.rwLayer);
        }
      }
    });

    MapFunctions.whenLayerToggled("lidProjectBmp", "modal", function (lidProjectBmpEnabled) {
      if (lidProjectBmpEnabled) {
        if (mapLayers.lidProjectBmpLayer) {
          modalMap.addLayer(mapLayers.lidProjectBmpLayer);
        } else {
          Actions.loadLidProjectBmps("modal");
        }
      } else {
        if (MapFunctions.mapHasLayer(modalMap, mapLayers.lidProjectBmpLayer)) {
          modalMap.removeLayer(mapLayers.lidProjectBmpLayer);
        }
      }
    });

    // whenLayerDataUpdated
    MapFunctions.whenLayerDataUpdated("drainage", "modal", (data) => {
      if (modalMap && data.features.length) {
        if (MapFunctions.mapHasLayer(modalMap, mapLayers.drainageLayer)) {
          modalMap.removeLayer(mapLayers.drainageLayer);
        }
        mapLayers.drainageLayer = MapFunctions.addDrainageLayer(
          modalMap,
          mapLayers.drainageLayer,
          data,
          Session.isRegulator(),
        );
        mapLayers.drainageLayer.addTo(modalMap);
        modalMap.fitBounds(mapLayers.drainageLayer.getBounds());
      }
    });

    MapFunctions.whenLayerDataUpdated("fullDrainageFcs", "modal", function (data) {
      mapLayers.fullDrainageFcsLayer = MapFunctions.addFullDrainageLayer(
        modalMap,
        mapLayers.fullDrainageFcsLayer,
        data,
        "fcs",
      );
      MapFunctions.displayFullDrainageLayer(modalMap, mapLayers, "fcs");
    });

    MapFunctions.whenLayerDataUpdated("fullDrainageBmp", "modal", function (data) {
      mapLayers.fullDrainageBmpLayer = MapFunctions.addFullDrainageLayer(
        modalMap,
        mapLayers.fullDrainageBmpLayer,
        data,
        "bmp",
      );
      MapFunctions.displayFullDrainageLayer(modalMap, mapLayers, "bmp");
    });

    MapFunctions.whenLayerDataUpdated("constructionProjectArea", "modal", function (data) {
      mapLayers.constructionProjectAreaLayer = MapFunctions.addConstructionProjectAreaLayer(
        modalMap,
        mapLayers.constructionProjectAreaLayer,
        data,
      );
    });

    MapFunctions.whenLayerDataUpdated("stormdrains", "modal", function (data) {
      StormdrainLayer.addAllStormdrainLayers(modalMap, mapLayers, data, "modal");
    });

    MapFunctions.whenLayerDataUpdated("streams", "modal", function (data) {
      mapLayers.rwLayer = MapFunctions.addStreamLayer(modalMap, mapLayers, data);
    });

    MapFunctions.whenLayerDataUpdated("lidProjectBmp", "modal", function (data) {
      mapLayers.lidProjectBmpLayer = MapFunctions.addBmpLayer(
        modalMap,
        mapLayers.lidProjectBmpLayer,
        data,
        "modal",
      );
    });
  };

  var bounceSingleMarker = function () {
    var marker = getMarker();
    if (marker) {
      //marker.bounce(4);
    }
  };

  var updateSingleMarkerIcon = function (iconObj) {
    const marker = getMarker();
    if (marker) {
      marker.setIcon(iconObj);
    }
  };

  var hideLocationMessage = function () {
    $(".setLocationMessageBox").hide();
    $(".setLocationMessage").hide();
  };

  var showLocationMessage = function (text) {
    $(".setLocationMessageBox").show();
    $(".setLocationMessage").show();
    $(".setLocationMessage").text(text);
  };

  var showModalMapLegendGroup = function (position = 0) {
    $("#modal-legend-group").show();
    $("#modal-legend-group").css("margin-top", `${position}px`);
  };

  var resetModalDisplayOptions = function () {
    $("#modal-legend-group").css("top", "14px");
    $("#modal-legend-group .layers-body").hide();
    $("#modal-legend-group .expand-arrow").removeClass("open");
    $("#modal-legend-group .legend-button").hide();
    Tree.set("modalLegendShowing", false);
  };

  var setSingleMarker = function (singleMarker) {
    mapLayers.singleMarkerLayer = singleMarker;
    singleMarker.addTo(modalMap);
  };

  function createBoundaryLayer() {
    const boundsLayer = L.geoJson(null, {
      pane: "ms4BoundaryPane",
      interactive: false,
      style: MapStyles.styleCatchmentOutline,
    });
    return boundsLayer;
  }

  function loadBoundary() {
    const groupId = Tree.get(["activeGroup", "groupId"]);
    ApiCalls.getBoundary(groupId, (data) => {
      const geoJson = CleanData.cleanGeoJson(data);
      mapLayers.boundsLayer.addData(geoJson);
      Tree.set(["layers", "bounds", "isFetching"], false);
      Tree.set(["layers", "bounds", "dataModal"], geoJson);
    });
  }

  var modalMapMoveZoomEnd = function () {
    Tree.set("bbox", modalMap.getBounds().toBBoxString());
    const zoomLevel = modalMap.getZoom();

    if (mapLayers.stormdrainLayer) {
      StormdrainLayer.handleStormdrainDisplay(modalMap, mapLayers, "modal");
    }
    MapFunctions.handleRWDisplay(modalMap, mapLayers, "modal");

    if (zoomLevel < 14) {
      const zoomedPastMuni = !MapFunctions.isMuniScaleZoom(zoomLevel);

      if (!zoomedPastMuni && Progeny.activeHasProgeny()) {
        return;
      }
      Misc.toggleDisabledInputs($(".checkbox.disabled-zoomed-out"), zoomedPastMuni);
    }
  };

  var getMarker = function (latLng = null) {
    return getSingleMarker(latLng);
  };

  var getSingleMarker = function (latLng) {
    if (MapFunctions.mapHasLayer(modalMap, mapLayers.singleMarkerLayer)) {
      return mapLayers.singleMarkerLayer;
    } else {
      if (latLng) {
        createNewSingleMarker(latLng);
      } else {
        if (modalMapHandlerConfiguration.newExistingMarkerHandler !== null) {
          modalMapHandlerConfiguration.newExistingMarkerHandler(18);
        } else {
          console.error("modalMapHandlerConfiguration.newExistingMarkerHandler is not set");
        }
      }
      return mapLayers.singleMarkerLayer;
    }
  };

  var setMarkerDragHandlers = function (marker, newMarker) {
    marker.dragging.enable();
    marker.off("dragstart dragend");
    if (modalMapHandlerConfiguration.dragEndHandler !== null) {
      marker.on("dragend", () => {
        modalMapHandlerConfiguration.dragEndHandler(marker.getLatLng(), newMarker);
      });
    }
  };
  var createSingleRotatingOutFallMarker = function (latlng, rotation, isPriority) {
    const iconRotationOffset = -180;

    mapLayers.singleMarkerLayer = L.marker(latlng, {
      pane: "outfallPane",
      icon: OutfallsIcon.getOutfallsMarkerIcon(isPriority),
      rotationAngle: rotation + iconRotationOffset,
      rotationOrigin: "center",
    });
    return mapLayers.singleMarkerLayer.addTo(modalMap);
  };

  var createNewSingleMarker = function (latlng) {
    const zoom = 15;
    mapLayers.singleMarkerLayer = new L.marker(latlng, {
      icon: MapStyles.getNewMapIcon(zoom),
      zIndexOffset: 2000,
    });
    return mapLayers.singleMarkerLayer.addTo(modalMap);
  };

  var createLineAssetLayer = function (geoJson) {
    mapLayers.lineAssetLayer = L.featureGroup([
      L.geoJSON(geoJson, { interactive: false, style: MapStyles.styleLineAssetCasing() }),
      L.geoJSON(geoJson, { interactive: false, style: MapStyles.styleLineAsset() }),
    ]);
    mapLayers.lineAssetLayer.addTo(modalMap);
    return mapLayers.lineAssetLayer;
  };

  var removeLineAssetLayer = function () {
    if (modalMapHasLayer("lineAssetLayer")) {
      removeMapLayer("lineAssetLayer");
    }
  };

  var zoomToLineAsset = function () {
    if (mapLayers.lineAssetLayer) {
      modalMap.fitBounds(mapLayers.lineAssetLayer.getBounds(), { padding: [20, 20] });
    }
  };

  var showBlueDot = function () {
    const location = Tree.get("blueDotLatLng");
    if (location) {
      if (mapLayers.blueDotLayer !== null) {
        modalMap.removeLayer(mapLayers.blueDotLayer);
      }
      mapLayers.blueDotLayer = L.featureGroup();
      blueDot = L.circleMarker(location, {
        pane: "blueDotPane",
      });
      blueDot.addTo(mapLayers.blueDotLayer);
      mapLayers.blueDotLayer.addTo(modalMap);
    }
  };

  var disableMarkerRelocation = function () {
    //@TODO need to make marker read only
    modalMap.off("click");
    if (
      MapFunctions.mapHasLayer(modalMap, mapLayers.singleMarkerLayer) &&
      mapLayers.singleMarkerLayer.dragging
    ) {
      mapLayers.singleMarkerLayer.dragging.disable();
      mapLayers.singleMarkerLayer.off("dragend");
    }
  };

  var modalMapHasLayer = function (layer) {
    if (modalMap && MapFunctions.mapHasLayer(modalMap, mapLayers[layer])) {
      return true;
    } else {
      return false;
    }
  };

  var getMap = function () {
    return modalMap;
  };

  var getDrainageLayer = function () {
    return mapLayers.drainageLayer;
  };

  var getMapLayers = function () {
    return mapLayers;
  };

  var getMapLayer = function (layer) {
    return mapLayers[layer];
  };

  var addMapLayer = function (layer) {
    modalMap.addLayer(mapLayers[layer]);
  };

  var removeMapLayer = function (layer) {
    modalMap.removeLayer(mapLayers[layer]);
  };

  var resetModalMap = function () {
    resetModalMapHandlers();
    resetModalMapLayers();
    resetModalDisplayOptions();
    resetModalMapClickListeners();
    afterCloseInventory();

    if (modalMap?.ruler) {
      MapFunctions.closeRuler(modalMap.ruler);
    }
  };

  var afterCloseInventory = function () {
    DataViewFunctions.getCurrentDataViewProperty("afterCloseInventory")?.();
  };

  var resetModalMapLayers = function () {
    resetModalMapTreeLayers();
    resetModalMapMapLayers();
  };

  var resetModalMapTreeLayers = function () {
    var layers = Tree.get("layers");
    for (const layer in layers) {
      if (layers[layer].dataModal) {
        Tree.set(["layers", layer, "dataModal"], []);
      }
      if (layers[layer].isEnabledModal) {
        DisplayOptions.handleLayerDisplay(layer, false, "modal");
      }
    }
  };

  var resetModalMapMapLayers = function () {
    var modalLayersConfig = LayerFunctions.getPropertyForAllLayers("doNotReset");
    for (const layerName in modalLayersConfig) {
      if (!modalLayersConfig[layerName]) {
        const layerKey = LayerFunctions.getLayerKeyByLayerName(layerName);

        if (MapFunctions.mapHasLayer(modalMap, mapLayers[layerKey]) || mapLayers[layerKey]) {
          modalMap.removeLayer(mapLayers[layerKey]);
          mapLayers[layerKey] = null;
        }
      }
    }
  };

  var closePopups = function () {
    if (modalMap) {
      modalMap.closePopup();
    }
  };

  var removeMarkerLayer = function () {
    if (modalMapHasLayer("singleMarkerLayer")) {
      removeMapLayer("singleMarkerLayer");
    }
  };

  var refreshMarkerLayer = function () {
    if (modalMapHasLayer("singleMarkerLayer")) {
      removeMapLayer("singleMarkerLayer");
      getMarker();
    }
  };

  var zoomToMarker = function (areaSelection = false) {
    const marker = getMarker();
    if (marker) {
      const latlng = [marker.getLatLng()];
      const map = getMap();
      map.fitBounds(L.latLngBounds(latlng));
      if (areaSelection) {
        map.setZoom(18);
      }
    }
  };

  var isModalMapVisible = function () {
    const container = getMap()?.getContainer();

    if (!container) {
      return false;
    }

    return $(container).is(":visible");
  };

  return {
    init,
    resetModalMapHandlers,
    configureModalMapHandlers,
    loadModalMapClickListeners,
    showModalMap,
    updateModalMapDisplay,
    showModalMapLegendGroup,
    createNewSingleMarker,
    createLineAssetLayer,
    removeLineAssetLayer,
    zoomToLineAsset,
    disableMarkerRelocation,
    hideLocationMessage,
    showLocationMessage,
    setMarkerDragHandlers,
    setSingleMarker,
    bounceSingleMarker,
    modalMapHasLayer,
    getMap,
    getMarker,
    getDrainageLayer,
    getMapLayers,
    getMapLayer,
    addMapLayer,
    removeMapLayer,
    closePopups,
    removeMarkerLayer,
    refreshMarkerLayer,
    updateSingleMarkerIcon,
    zoomToMarker,
    initializeModalMap,
    isModalMapVisible,
    resetModalMap,
    createSingleRotatingOutFallMarker,
    loadModalMap,
    setModalMapView,
  };
};

module.exports = ModalMap();

const Actions = require("../actions");
const ApiCalls = require("../apiCalls");
const BasemapFunctions = require("./basemapFunctions");
const CleanData = require("./cleanData");
const DataViewFunctions = require("../dataViewFunctions");
const DisplayOptions = require("./displayOptions");
const LayerFunctions = require("../layerFunctions");
const LeafletExtensions = require("./leafletExtensions");
const MainMapController = require("./mainMapController");
const MapFunctions = require("./mapFunctions");
const MapPaneFunctions = require("./mapPaneFunctions");
const MapStyles = require("./mapStyles");
const Misc = require("../misc");
const OutfallsIcon = require("../outfalls/outfallsIcon");
const Progeny = require("../login/progeny");
const Session = require("../login/session");
const StormdrainLayer = require("../general/stormdrainLayer");
const Tree = require("../tree");
const BulkSelectTable = require("../bulkSelect/bulkSelectTable");
const ToolSettings = require("../settings/toolSettings");
const CustomLayer = require("./customLayer");
require("./modalMapLegend");
